import type { CSSProperties } from 'react'
import type { Asset, Product } from '@/types'

export function getAssetThumbnailUrl(asset: Asset): string | null {
  return asset.thumbnail_url || (asset.asset_type === 'image' ? asset.url : null)
}

export function getAssetAspectRatioStyle(asset: Pick<Asset, 'width' | 'height'>): CSSProperties | undefined {
  if (!asset.width || !asset.height) {
    return undefined
  }
  return { aspectRatio: `${asset.width} / ${asset.height}` }
}

export function getProductScreenshotThumbnailUrl(product: Pick<Product, 'screenshot_thumbnail_url' | 'screenshot_url'>): string | null {
  return product.screenshot_thumbnail_url || product.screenshot_url
}
